import { render, staticRenderFns } from "./PositionCustomization.vue?vue&type=template&id=4124feae&scoped=true&"
import script from "./PositionCustomization.vue?vue&type=script&lang=js&"
export * from "./PositionCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124feae",
  null
  
)

export default component.exports